import { render } from "./MapTab.vue?vue&type=template&id=56f8cd4a&scoped=true"
import script from "./MapTab.vue?vue&type=script&lang=js"
export * from "./MapTab.vue?vue&type=script&lang=js"

import "./MapTab.vue?vue&type=style&index=0&id=56f8cd4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f8cd4a"]])

export default __exports__